module.exports = __webpack_public_path__ + "img/pic-logo-ipstar.bc8dde5f.png";